import React, { useState, useEffect } from "react";
import { Modal, Input, message } from "antd";
import { Image } from "react-bootstrap";
import whiteLogo from "../../Assets/logo.webp"; 

import './ContactModal.scss';

function ContactModal({ isModalOpen, handleCancel }) {
  const [formData, setFormData] = useState({ name: "", email: "", company: "", message: "" });
  const [emailError, setEmailError] = useState("");
  const [result, setResult] = useState("");

  useEffect(() => {
    if (isModalOpen) {
      setResult("");
      setEmailError("");
    }
  }, [isModalOpen]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      setEmailError(validateEmail(value) ? "" : "Please enter a valid email address.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult("Sending...");
    setEmailError("");

    if (!validateEmail(formData.email)) {
      setEmailError("Please enter a valid email address.");
      setResult("");
      return;
    }
    const formSubmission = new FormData();
    formSubmission.append("name", formData.name);
    formSubmission.append("email", formData.email);
    formSubmission.append("company", formData.company);
    formSubmission.append("message", formData.message);
    formSubmission.append("access_key", process.env.REACT_APP_FORM_KEY);

    formSubmission.append("from_name", "Klean Leaf Website");
    formSubmission.append("subject", "New Contact Form Submission - Klean Leaf");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formSubmission,
      });

      const data = await response.json();

      if (data.success) {
        setResult("Form Submitted Successfully!");
        message.success("Your message has been sent!");
        setFormData({ name: "", email: "", company: "", message: "" });
        setTimeout(() => handleCancel(), 1500);
      } else {
        setResult(data.message);
        message.error("There was an issue submitting the form.");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setResult("Something went wrong. Please try again.");
      message.error("Something went wrong. Please try again.");
    }
  };

  return (
    <Modal
      title="Ready to try Klean Leaf?"
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      className="contact-modal-wrapper"
    >
      <div className="modal-contact">
        <Image src={whiteLogo} alt="Klean Leaf logo" className="modal-logo" />
        <p className="modal-subtitle">Fill out the form and our team will follow up about private label laundry detergent sheet samples, packaging options, MOQ, and timing.</p>

        <form onSubmit={handleSubmit} className="home-contact-form">
          <label>Name *</label>
          <Input type="text" name="name" value={formData.name} onChange={handleChange} required />

          <label>Email *</label>
          <Input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          {emailError && <span className="error-message">{emailError}</span>}

          <label>Company</label>
          <Input type="text" name="company" value={formData.company} onChange={handleChange} />

          <label>Message *</label>
          <Input.TextArea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="message-box"
            required
          />

          <button type="submit" className="submit-button primary-btn">
            Submit
          </button>
        </form>
        <span className="form-result">{result}</span>
      </div>
    </Modal>
  );
}

export default ContactModal;
